
import { defineComponent } from "vue";

import Modal from "../Components/Modal.vue";
import TournamentCard from "./TournamentCard.vue";

interface Props {
  id: any;
}

export default defineComponent({
  name: "TournamentModal",

  computed: {
    players: () => [
      { id: 1, name: "Player 1", icon: { name: "user" } },
      { id: 2, name: "Player 2", icon: {} },
      { id: 3, name: "Player 3", icon: { name: "user" } },
      { id: 4, name: "Player 4", icon: {} },
      { id: 5, name: "Player 5", icon: { name: "user" } },
      { id: 6, name: "Player 6", icon: { name: "user", color: "#0000007a" } },
      { id: 7, name: "Player 7", icon: { name: "user" } },
      { id: 8, name: "Player 8", icon: { name: "user", color: "#0000007a" } },
    ],

    finals: ({ players }) => ({
      id: 1,
      status: "in progress",
      winner: null,
      players: players.filter(({ id }: Props) => id === 1 || id === 7),
    }),

    semiFinalMatches: ({ players }) => [
      {
        id: 1,
        status: "finished",
        winner: 1,
        players: players.filter(({ id }: Props) => id === 1 || id === 4),
      },
      {
        id: 2,
        status: "finished",
        winner: 7,
        players: players.filter(({ id }: Props) => id === 6 || id === 7),
      },
    ],

    quarterFinalMatches: ({ players }) => [
      {
        id: 1,
        status: "finished",
        winner: 1,
        players: players.filter(({ id }: Props) => id === 1 || id === 2),
      },
      {
        id: 2,
        status: "finished",
        winner: 4,
        players: players.filter(({ id }: Props) => id === 3 || id === 4),
      },
      {
        id: 3,
        status: "finished",
        winner: 6,
        players: players.filter(({ id }: Props) => id === 5 || id === 6),
      },
      {
        id: 4,
        status: "finished",
        winner: 7,
        players: players.filter(({ id }: Props) => id === 7 || id === 8),
      },
    ],
  },

  components: { Modal, TournamentCard },
});
